/**
 * CUAConsentModal — consent dialog shown when CUA grant is required
 * Reference: TASK-UI-CU-005-1, SOL-UI-CU-005
 */

import React from 'react';
import { useCUAConsent } from '../hooks/useCUAConsent';

export function CUAConsentModal() {
  const { visible, consent, decline } = useCUAConsent();

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="cua-consent-title"
      aria-describedby="cua-consent-desc"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4"
    >
      <div className="bg-surface-elevated border border-border rounded-xl shadow-xl max-w-md w-full mx-4 p-6 space-y-5">
        <h2 id="cua-consent-title" className="font-semibold text-base text-text-primary">
          Cho phép AI truy cập màn hình?
        </h2>

        <div id="cua-consent-desc" className="space-y-3 text-sm">
          <div>
            <p className="text-muted font-medium mb-1">✅ Agent có thể:</p>
            <ul className="list-none space-y-0.5 text-sm ml-2">
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-success">•</span>
                <span>Chụp ảnh màn hình (DLP tự động che thông tin nhạy cảm)</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-success">•</span>
                <span>Click, nhập text, cuộn trong ứng dụng được phép</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-success">•</span>
                <span>Xem danh sách cửa sổ đang mở</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-muted font-medium mb-1">🚫 Agent KHÔNG thể:</p>
            <ul className="list-none space-y-0.5 text-sm ml-2">
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-warning">•</span>
                <span className="text-status-text-warning">Truy cập 1Password, Keychain, Bitwarden</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-warning">•</span>
                <span className="text-status-text-warning">Mở Terminal, SSH, iTerm</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-warning">•</span>
                <span className="text-status-text-warning">Truy cập System Preferences / Security</span>
              </li>
              <li className="flex items-start gap-1.5">
                <span className="mt-0.5 text-status-text-warning">•</span>
                <span className="text-status-text-warning">Nhập mật khẩu, API key, JWT token</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-surface-neutral rounded-lg p-3 text-xs text-muted">
          Quyền truy cập chỉ áp dụng cho <strong>phiên chat này</strong>. Ảnh màn hình được xử lý
          DLP tự động và lưu tối đa 30 ngày theo chính sách bảo mật.
        </div>

        <div className="flex gap-2">
          <button
            id="cua-consent-decline-btn"
            type="button"
            onClick={decline}
            className="flex-1 px-3 py-2 text-sm border border-border rounded-lg hover:bg-surface-neutral text-text-primary transition-colors"
          >
            Không cho phép
          </button>
          <button
            id="cua-consent-grant-btn"
            type="button"
            onClick={consent}
            className="flex-1 px-3 py-2 text-sm bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 font-medium transition-colors"
          >
            Cho phép lần này
          </button>
        </div>
      </div>
    </div>
  );
}
